import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import localConfig from '../../config/local.json'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    apiKey: null,
    defaultShopId: null,
    selectedEvent: null,
    selectedEvents: [],
    selectedResource: null,
    selectedResources: [],
    selectedResourcePool: null,
    selectedResourcePools: [],
    selectedTime: null,
    selectedTimes: [],
    loginFailed: false,
    baseDomain: localConfig.baseDomain,
    bridgeUri: localConfig.bridgeUri,
    externalScanner: false
  },
  plugins: [
    createPersistedState({
      paths: [
        'apiKey',
        'defaultShopId',
        'selectedEvent',
        'selectedEvents',
        'selectedResource',
        'selectedResources',
        'selectedResourcePool',
        'selectedResourcePools',
        'selectedTime',
        'selectedTimes',
        'externalScanner'
      ]
    })
  ],
  mutations: {
    login (state, data) {
      state.apiKey = data
    },
    loginFailed (state) {
      state.loginFailed = true
    },
    logout (state) {
      state.apiKey = null
      state.loginFailed = false
    },
    setDefaultShopId (state, data) {
      state.defaultShopId = data
    },
    setSelectedEvent (state, data) {
      state.selectedEvent = data
    },
    setSelectedEvents (state, data) {
      state.selectedEvents = data
    },
    setSelectedResource (state, data) {
      state.selectedResource = data
    },
    setSelectedResources (state, data) {
      state.selectedResources = data
    },
    setSelectedResourcePool (state, data) {
      state.selectedResourcePool = data
    },
    setSelectedResourcePools (state, data) {
      state.selectedResourcePools = data
    },
    setSelectedTime (state, data) {
      state.selectedTime = data
    },
    setSelectedTimes (state, data) {
      state.selectedTimes = data
    },
    setExternalScanner (state, data) {
      state.externalScanner = data
    },
    setBaseDomain (state, data) {
      state.baseDomain = data
    },
    setBridgeUri (state, data) {
      state.bridgeUri = data
    }
  },
  actions: {
    login ({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        commit('logout')
        commit('setDefaultShopId', data.shopId)
        fetch('https://' + state.baseDomain + '/' + data.shopId + '/login.json', {
          method: 'POST',
          headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' }),
          body: 'user=' + encodeURIComponent(data.email) + '&pass=' + encodeURIComponent(data.password) + '&legacy_client=reader'
        }).then(response => {
          let apiKeyFound = false
          response.headers.forEach(function(value, key) {
            if(key === 'x-apikey') {
              apiKeyFound = true
              commit('login', value)
              resolve()
            }
          })
          if (!apiKeyFound) {
            console.log('auth error')
            commit('loginFailed')
            reject()
          }
        }).catch(function(e) {
          commit('loginFailed')
          console.log('error')
          console.log(e)
          reject()
        })
      })
    },
    logout ({ commit }) {
      commit('logout')
    },
    setSelectedEvent({ commit }, data) {
      commit('setSelectedEvent', data)
    },
    setSelectedEvents({ commit }, data) {
      commit('setSelectedEvents', data)
    },
    setSelectedResource({ commit }, data) {
      commit('setSelectedResource', data)
    },
    setSelectedResources({ commit }, data) {
      commit('setSelectedResources', data)
    },
    setSelectedResourcePool({ commit }, data) {
      commit('setSelectedResourcePool', data)
    },
    setSelectedResourcePools({ commit }, data) {
      commit('setSelectedResourcePools', data)
    },
    setSelectedTime({ commit }, data) {
      commit('setSelectedTime', data)
    },
    setSelectedTimes({ commit }, data) {
      commit('setSelectedTimes', data)
    },
    setExternalScanner({ commit }, data) {
      commit('setExternalScanner', data)
    },
    setBaseDomain({ commit }, data) {
      commit('setBaseDomain', data)
    },
    setBridgeUri({ commit }, data) {
      commit('setBridgeUri', data)
    }
  },
  getters: {
    apiKey (state) {
      return state.apiKey
    },
    defaultShopId (state) {
      return state.defaultShopId
    },
    selectedEvent (state) {
      return state.selectedEvent
    },
    selectedEvents (state) {
      return state.selectedEvents
    },
    selectedResource (state) {
      return state.selectedResource
    },
    selectedResources (state) {
      return state.selectedResources
    },
    selectedResourcePool (state) {
      return state.selectedResourcePool
    },
    selectedResourcePools (state) {
      return state.selectedResourcePools
    },
    selectedTime (state) {
      return state.selectedTime
    },
    selectedTimes (state) {
      return state.selectedTimes
    },
    externalScanner (state) {
      return state.externalScanner
    },
    baseDomain (state) {
      return state.baseDomain
    },
    bridgeUri (state) {
      return state.bridgeUri
    }
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js